import Quill from 'quill';
import React from 'react';
import SelectInputDrawer from 'src/components/10-atoms/form/inputs/SelectInput/SelectInputDrawer';
import { ISelectionType } from 'src/components/10-atoms/form/inputs/SelectInput/types';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { isMac } from 'src/utils/platform';
const MODIFIER_KEY_PREFIX = isMac ? '⌘' : 'Ctrl';
const HEADING_OPTIONS = [
    { id: 0, title: () => React.createElement("p", null, "Paragraph"), description: `(${MODIFIER_KEY_PREFIX} + 0)` },
    { id: 1, title: () => React.createElement("h1", null, "Heading 1"), description: `(${MODIFIER_KEY_PREFIX} + 1)` },
    { id: 2, title: () => React.createElement("h2", null, "Heading 2"), description: `(${MODIFIER_KEY_PREFIX} + 2)` },
    { id: 3, title: () => React.createElement("h3", null, "Heading 3"), description: `(${MODIFIER_KEY_PREFIX} + 3)` },
    { id: 4, title: () => React.createElement("h4", null, "Heading 4"), description: `(${MODIFIER_KEY_PREFIX} + 4)` },
    { id: 5, title: () => React.createElement("h5", null, "Heading 5"), description: `(${MODIFIER_KEY_PREFIX} + 5)` },
    { id: 6, title: () => React.createElement("h6", null, "Heading 6"), description: `(${MODIFIER_KEY_PREFIX} + 6)` },
];
export default function useHeadingActions(quill) {
    const applyHeading = useStableCallback((level) => {
        if (!quill) {
            return;
        }
        const formatValue = level === false || level === 0 ? false : level;
        quill.format('header', formatValue, Quill.sources.USER);
    });
    const showDrawer = useStableCallback(() => {
        if (!quill) {
            return;
        }
        const range = quill.getSelection(true);
        const formats = quill.getFormat(range);
        const currentHeader = formats?.header;
        const currentLevel = currentHeader && typeof currentHeader === 'number' && currentHeader >= 1 && currentHeader <= 6
            ? currentHeader
            : 0;
        const selectedOption = HEADING_OPTIONS.find(option => option.id === currentLevel);
        bottomDrawerHelperActions.show({
            component: (React.createElement(SelectInputDrawer, { type: ISelectionType.SINGLE, value: selectedOption, options: HEADING_OPTIONS, title: "Choose a heading", onCancel: bottomDrawerHelperActions.hide, onChange: option => {
                    bottomDrawerHelperActions.hide();
                    applyHeading(option.id === 0 ? false : option.id);
                } })),
        });
    });
    return {
        showDrawer,
        applyHeading,
    };
}
